import { ChevronDown } from "lucide-react";

import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { cn } from "@/lib/utils";
import { SharePermissionState } from "@/types/permissions";

export const PERMISSION_LABELS: Record<SharePermissionState, string> = {
  VIEW: "Can View",
  SHARE: "Can Share",
  MONITOR: "Can Monitor",
  EDIT: "Can Edit",
  REMOVE: "Remove",
};

interface PermissionDropdownProps {
  value: SharePermissionState;
  onChange: (value: SharePermissionState) => void;
  availablePermissions?: SharePermissionState[];
  showRemove?: boolean;
  className?: string;
}

export function PermissionDropdown({
  value,
  onChange,
  availablePermissions = ["VIEW", "EDIT", "SHARE"],
  showRemove = true,
  className,
}: PermissionDropdownProps) {
  const showOnlyRemove = availablePermissions.length === 0;

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          intent="secondary"
          size="sm"
          className={cn("w-[120px] justify-between", className)}
        >
          {showOnlyRemove ? PERMISSION_LABELS.VIEW : PERMISSION_LABELS[value]}
          <ChevronDown />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-40">
        {!showOnlyRemove &&
          availablePermissions.map((permission) => (
            <DropdownMenuItem
              key={permission}
              onClick={() => onChange(permission)}
            >
              {PERMISSION_LABELS[permission]}
            </DropdownMenuItem>
          ))}
        {!showOnlyRemove && showRemove && <DropdownMenuSeparator />}
        {showRemove && (
          <DropdownMenuItem
            onClick={() => onChange("REMOVE")}
            className="text-destructive focus:text-destructive"
          >
            Remove Access
          </DropdownMenuItem>
        )}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
